<template>
    <Carousel
        :key="forceUpdate"
        :class="bgClass"
    >
        <template #header>
            <div class="flex items-center">
                <span class="flex-initial icon icon-documents w-8 h-8 mr-2"></span>
                <h2 class="flex-1 font-subtitle-3 md:font-subtitle-2 line-clamp-2 break-word-please">
                    {{ item.h2 }}
                </h2>
            </div>
        </template>
        <template #content>
            <slot name="content"></slot>
        </template>
        <template #slides>
            <div
                v-for="document in item.data"
                :key="document.id"
                class="py-1"
            >
                <div class="bg-white w-80 pt-4 px-4 pb-2 my-1 shadow rounded-lg md:w-84">
                    <div class="flex mb-3">
                        <a
                            :href="document.link"
                            :alt="document.h3"
                            class="flex-none mr-4"
                        >
                            <AssetCdnImage
                                :src="document.image"
                                :alt="item.h2"
                                :width="88"
                                :height="88"
                                object-fit="cover"
                                class="bg-slate-50 rounded-lg w-22 h-22"
                            />
                        </a>
                        <div>
                            <h3
                                v-tooltip="document.short_file_name"
                                class="text-blue-600 text-base font-normal line-clamp-2 leading-6 mb-1 break-word-please"
                            >
                                <a
                                    :href="document.link"
                                    :alt="document.h3"
                                >
                                    {{ document.h3 }}
                                </a>
                            </h3>
                            <p class="h-10 text-sm text-slate-400 line-clamp-2 leading-5 break-word-please">
                                {{ document.text }}
                            </p>
                        </div>
                    </div>
                    <TagList
                        class="justify-end"
                        tag-size="sm"
                        tag-bare
                        :tags="getStats(document)"
                    />
                </div>
            </div>
        </template>
        <template #footer>
            <WidgetFooter
                :text="item.text"
                :button-link="item.button_link"
                :button-target="item.button_target"
                :button-text="item.button_text"
            ></WidgetFooter>
        </template>
    </Carousel>
</template>

<script>
import Carousel from '@components/Carousel';
import { mapGetters } from 'vuex';
import WidgetFooter from './WidgetFooter.vue';

export default {
    name: 'DocumentsWidget',
    components: {
        WidgetFooter,
        Carousel,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        bgClass: {
            type: String,
            default: 'bg-slate-50',
        },
    },
    data() {
        return {
            forceUpdate: 1,
        };
    },
    computed: {
        ...mapGetters('ui', ['getLocale']),
        lang() {
            return this.getLocale.slice(0, 2);
        },
    },
    watch: {
        'item.data': function itemDataWatcher() {
            // carousel is unable to detect content change
            this.forceUpdate += 1;
        },
    },
    methods: {
        getStats(document) {
            return [
                { icon: 'heart', value: document.up_votes },
                { icon: 'discussions', value: document.posts },
                { icon: 'downloads', value: document.downloads },
            ];
        },
    },
};
</script>

<style lang="scss" scoped>
@screen md {
    .md\:w-84 {
        width: 21rem;
    }
}
</style>
